import styled from 'styled-components';
import Link from '../Link';

interface LabelLinkProps {
  as?: keyof JSX.IntrinsicElements;
  size?: 'small' | 'medium' | 'large';
}

const LabelLink = styled(Link).attrs<LabelLinkProps>(({ size = 'medium' }) => ({
  size,
}))<LabelLinkProps>`
  font-size: ${({ size }) =>
    size === 'small' ? '12px' : size === 'large' ? '16px' : '14px'};
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};

  color: ${({ theme }) => theme.palette.common.black};

  cursor: pointer;
  text-decoration: underline;
  transition: color 0.3s ease;

  &:hover {
    color: ${({ theme }) => theme.palette.primary.main};
  }
`;

export default LabelLink;
